import { render, staticRenderFns } from "./CompetencesStars.vue?vue&type=template&id=7baa95c2&"
import script from "./CompetencesStars.vue?vue&type=script&lang=js&"
export * from "./CompetencesStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports